import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot", { email }); setSent(true); }
    catch { toast.error("Something went wrong"); }
  };
  return (
    <div className="blz-container py-14 max-w-md">
      <h1 className="font-display text-3xl font-bold">Forgot password</h1>
      {sent ? (
        <div className="mt-6 card-flat p-6 text-sm">If an account exists for <span className="font-mono">{email}</span>, a reset link has been sent.</div>
      ) : (
        <form onSubmit={submit} className="card-flat p-6 mt-6 space-y-3">
          <label className="block"><span className="text-xs font-semibold">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full h-11 rounded-lg border border-slate-200 px-3" data-testid="forgot-email"/>
          </label>
          <button className="btn-primary w-full" data-testid="forgot-submit">Send reset link</button>
        </form>
      )}
    </div>
  );
}
